
import { Component, Vue } from 'vue-property-decorator';

@Component<AuthPage>({})
export default class AuthPage extends Vue {}
